export default __webpack_public_path__ + "static/2023-652199c5c846ebb9eacf1e4b6fd4bdef.png";